import { render, staticRenderFns } from "./Notice.List.vue?vue&type=template&id=61bacb76&"
import script from "./Notice.List.vue?vue&type=script&lang=js&"
export * from "./Notice.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports